import { createFileRoute } from '@tanstack/react-router';

import FreeGamesCreatePage from '~/setup/free/FreeGamesCreatePage';

export const Route = createFileRoute('/_protected/freegames/create')({
  component: FreeGamesCreatePage,
});
